import React from 'react';
import { Row, Col } from 'react-bootstrap';
import {
  ApprovalStatusFilterLabel,
  SettlementStatusFilterLabel,
} from '../../components/Sales/SaleStatusColumnHeaders';

const SalesListFiltersCard = ({
  filters,
  approvalStatusOptions,
  settlementStatusOptions,
  branchOptions = [],
  includeBranchFilter = false,
  loading,
  exporting,
  onFilterChange,
  onApplyFilters,
  onClearFilters,
  onExportExcel,
}) => (
  <div className="sales-filters-card">
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onApplyFilters();
      }}
    >
      <Row className="g-3 align-items-end">
        <Col xs={12} lg={includeBranchFilter ? 2 : 4}>
          <label htmlFor="sales-search" className="form-label sales-filters-card__label">
            Buscar
          </label>
          <input
            type="text"
            id="sales-search"
            className="form-control"
            placeholder="Cliente, DNI o N° préstamo..."
            name="search"
            value={filters.search}
            onChange={onFilterChange}
          />
        </Col>
        {includeBranchFilter && (
          <Col xs={12} sm={6} lg={2}>
            <label htmlFor="sales-branch" className="form-label sales-filters-card__label">
              Sucursal
            </label>
            <select
              id="sales-branch"
              className="form-select"
              name="branch_id"
              value={filters.branch_id}
              onChange={onFilterChange}
              aria-label="Filtrar por sucursal"
            >
              <option value="">Todas las sucursales</option>
              {branchOptions.map((branch) => (
                <option key={branch.id} value={branch.id}>
                  {branch.name}
                  {branch.identification ? ` (${branch.identification})` : ''}
                </option>
              ))}
            </select>
          </Col>
        )}
        <Col xs={12} sm={6} lg={2}>
          <ApprovalStatusFilterLabel htmlFor="sales-approval-status" />
          <select
            id="sales-approval-status"
            className="form-select"
            name="approval_status"
            value={filters.approval_status}
            onChange={onFilterChange}
          >
            <option value="">Todas</option>
            {approvalStatusOptions.map(({ value, label }) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>
        </Col>
        <Col xs={12} sm={6} lg={2}>
          <SettlementStatusFilterLabel htmlFor="sales-settlement-status" />
          <select
            id="sales-settlement-status"
            className="form-select"
            name="settlement_status"
            value={filters.settlement_status}
            onChange={onFilterChange}
          >
            <option value="">Todas</option>
            {settlementStatusOptions.map(({ value, label }) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>
        </Col>
        <Col xs={12} sm={6} lg={2}>
          <label htmlFor="sales-from-date" className="form-label sales-filters-card__label">
            Fecha desde
          </label>
          <input
            type="date"
            id="sales-from-date"
            className="form-control"
            name="from_date"
            value={filters.from_date}
            onChange={onFilterChange}
          />
        </Col>
        <Col xs={12} sm={6} lg={2}>
          <label htmlFor="sales-to-date" className="form-label sales-filters-card__label">
            Fecha hasta
          </label>
          <input
            type="date"
            id="sales-to-date"
            className="form-control"
            name="to_date"
            value={filters.to_date}
            onChange={onFilterChange}
          />
        </Col>
      </Row>

      <div className="sales-filters-actions">
        <div className="sales-filters-actions__left">
          <button
            type="submit"
            className="btn btn-light-primary"
            disabled={loading}
          >
            <i className="bi bi-funnel me-1" aria-hidden></i>
            Filtrar
          </button>
          <button
            type="button"
            className="btn btn-light-secondary"
            onClick={onClearFilters}
            disabled={loading}
          >
            <i className="bi bi-x-circle me-1" aria-hidden></i>
            Limpiar
          </button>
        </div>
        <div className="sales-filters-actions__right">
          <button
            type="button"
            className="btn btn-outline-success"
            onClick={onExportExcel}
            disabled={loading || exporting}
            title="Exportar a Excel según filtros aplicados"
            aria-label="Exportar a Excel según filtros aplicados"
          >
            <i className="bi bi-file-earmark-spreadsheet me-1" aria-hidden></i>
            {exporting ? 'Exportando...' : 'Exportar a Excel'}
          </button>
        </div>
      </div>
    </form>
  </div>
);

export default SalesListFiltersCard;
